import React, { Component } from 'react'

export default class enquiryIcon extends Component {
    render() {
        return (
            <svg className={this.props.className} onClick={this.props.onClick} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.3346 1.66602L9.16797 10.8327" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M18.3346 1.66602L12.5013 18.3327L9.16797 10.8327L1.66797 7.49935L18.3346 1.66602Z" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        )
    }
}

